import React from "react";
import { Link } from "react-router-dom";
import { useBranding } from "@/lib/branding";

export const Brand = ({ to = "/", compact = false }) => {
  const { club_logo_url, club_name } = useBranding();
  const displayName = (club_name && club_name.trim()) || "Derwent Cricket Club";
  // ``compact`` renders a smaller, horizontal crest + inline tagline
  // so the brand fits inside the 64px sidebar header. The default
  // stacked variant is used everywhere else (public header/footer).
  if (compact) {
    return (
      <Link to={to} className="inline-flex items-center gap-2 group min-w-0" data-testid="brand-link">
        {club_logo_url ? (
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-md overflow-hidden shrink-0">
            <img
              src={club_logo_url}
              alt={`${displayName} logo`}
              className="h-full w-full object-contain"
              data-testid="brand-logo-image"
            />
          </span>
        ) : (
          <span className="inline-flex h-10 w-10 items-center justify-center rounded-md bg-[hsl(var(--fg))] text-[hsl(var(--bg))] shrink-0" data-testid="brand-logo-fallback">
            <span className="font-bold text-sm tracking-tighter">DC</span>
          </span>
        )}
        <span
          className="text-[11px] uppercase tracking-[0.22em] font-semibold text-white group-hover:text-white/90 transition-colors truncate"
          data-testid="brand-since"
        >
          Est. 1835
        </span>
      </Link>
    );
  }
  return (
    <Link to={to} className="inline-flex flex-col items-center gap-1 group" data-testid="brand-link">
    </Link>
  );
};

export default Brand;
